import { createAction } from "@reduxjs/toolkit";
export var resetState = createAction("reset-state");
export var fullReset = createAction("full-reset");
